/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { FC } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox, Loader } from '@nexigendigital/nxui'
import { useTransactionsQuery } from 'api/billing'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
 type ViewTransactionLightboxProps = {
    status: boolean,
    close: () => void
}

export const ViewTransactionLightbox: FC<ViewTransactionLightboxProps> = ({ status, close }) => {
    const { transaction } = useSelector((state: RootStateOrAny) => state.billing)
    const { isFetching } = useTransactionsQuery(transaction, { skip: !transaction })

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={`Transaction #${transaction}`}
            content={isFetching
                ? <Loader message={'Fetching transaction contents...'} />
                : (<div></div>)

            }
            conditions={{ state: status, action: () => close() }}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Resend',
                    color: 'primary',
                    func: () => console.log('run')
                }
            ]}
        />
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
